import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useFlavorScentContext() {
  const { flavorScents } = useContext<GlobalContextType>(GlobalContext);
  return flavorScents;
}
